import React, { type FC, type ReactNode } from 'react';
import { BrandPageBackground, Loading, LoadingBackground } from '@seddi/ui-kit';

import { useAppAuthLoad } from './appAuthLoad.hooks';

import backgroundImage from './background_image.png';

type AppAuthLoadProps = {
  children: ReactNode;
};

/**
 * Application loading after authentication.
 */
export const AppAuthLoad: FC<AppAuthLoadProps> = ({ children }) => {
  const { isLoaded, percentage } = useAppAuthLoad();
  return isLoaded ? (
    children
  ) : (
    <BrandPageBackground image={backgroundImage}>
      <LoadingBackground>
        <Loading name="Fitroom" percentage={percentage} />
      </LoadingBackground>
    </BrandPageBackground>
  );
};
